import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
const defaultDemandApiConfig = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json'
  }
};
const demandServicePath = '/gateway/api/marketplace/internal/demand';
const getSiteDetailsUrl = (mpacBaseUrl, cloudId, enableSiteDetailsDomainChange) => {
  const domain = enableSiteDetailsDomainChange ? '' : mpacBaseUrl;
  return "".concat(domain).concat(demandServicePath, "/site-details/cloud-id/").concat(cloudId);
};
export const getHostBillingSystem = cloudId => fetchOk("/gateway/api/marketplace/internal/demand/billing-system/".concat(cloudId)).then(response => response.json());
export const getSiteDetails = async (mpacBaseUrl, cloudId, enableSiteDetailsDomainChange) => {
  return (await fetchOk(getSiteDetailsUrl(mpacBaseUrl, cloudId, enableSiteDetailsDomainChange), _objectSpread({
    method: 'GET'
  }, defaultDemandApiConfig))).json();
};